import React from 'react';
import GenericFilter from './GenericFilter';

const LiveViewEventBookerFilter = (props) => (
  <GenericFilter {...props} titleKey="eventBooker" namePrefix="eventBooker" />
);

export default LiveViewEventBookerFilter;
